var React = require('react');

function ArrowCircle (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"stroke":"#66B2E4","strokeWidth":"2","cx":"14","cy":"14","r":"13","key":0}),React.createElement("path",{"fill":"#66B2E4","d":"M16.5 18.187L12.427 14.2l4.073-3.987L15.287 9 10 14.2l5.287 5.2z","key":1})]));
}

ArrowCircle.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28"};

module.exports = ArrowCircle;

ArrowCircle.default = ArrowCircle;
